import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useLongPress } from 'use-long-press';
import { useState } from 'react';

import { getSelectedDriver, planPageShow } from 'redux/PlanPageSlice';

// import IndicatorPage from './IndicatorPage';
import { createInputPanelEditRefetch } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/planPageFetchHelpers';

import DimesionPage from './DimensionPage';
import OrganisationType from './OrganisationType';
import IndicatorPageMultiDim from './IndicatorPageMultiDim';

import type { PlanPageRefetchRequest } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/planPageFetchHelpers';

export interface Properties {
  refetchRequest: PlanPageRefetchRequest;
}

const InputSection = ({ refetchRequest }: Properties) => {
  const [isLongClicked, setIsLongClicked] = useState<boolean>(false);

  const longClickCheck = useLongPress(() => {
    setIsLongClicked((previousState: any) => !previousState);
  });

  const currentDriver = useSelector(getSelectedDriver);
  const showPlanPage = useSelector(planPageShow);

  const onInputEdit = createInputPanelEditRefetch(refetchRequest, showPlanPage, currentDriver);

  const showCurrentPage = () => {
    if (currentDriver?.type === 'dimension') {
      return (
        <OrganisationType
          longClickCheck={longClickCheck}
          isLongClicked={isLongClicked}
          refetchRequest={refetchRequest}
          onInputEdit={onInputEdit}
        />
      );
    }
    if (currentDriver?.type === 'indicator') {
      return <IndicatorPageMultiDim refetchRequest={refetchRequest} />;
    }
    return <DimesionPage refetchRequest={refetchRequest} onInputEdit={onInputEdit} />;
  };

  return (
    <Box h='100%' className='scroll' display='flex' flexDirection='column' overflow='hidden'>
      <Box flex='1' minH={0} overflow='hidden'>
        {showCurrentPage()}
      </Box>
    </Box>
  );
};

export default InputSection;
